module.exports = __webpack_public_path__ + "static/img/7047b84a3a514b3554e89d66755efca2.f5ae8fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/7047b84a3a514b3554e89d66755efca2.jpg
// module id = +bf7
// module chunks = 4